import { Link } from 'react-router-dom';

import { Card } from '@/components/ui/card';
import { Icon } from '@/components/common/Icon';
import Loader from '@/components/common/Loader';
import { useActivitiesV2 } from '@/data/activity';

const ActivityGrid = () => {
  const activities = useActivitiesV2('isEnabled=true');

  if (activities.isLoading && !activities.data) {
    return <Loader />;
  }

  return (
    <div className="grid grid-cols-[repeat(auto-fill,minmax(160px,1fr))] gap-5 mb-5 p-2">
      {activities.data.query.map((activityId) => {
        const activity = activities.data.content[activityId];
        return (
          <Card key={activity.id}>
            <Link to={`/coach?activityId=${activity.id}`}>
              <div className="p-6 flex flex-col items-center justify-center text-center gap-4">
                <Icon name={activity.icon} size={48} />
                <h3 className="text-lg font-semibold">{activity.title}</h3>
              </div>
            </Link>
          </Card>
        );
      })}
    </div>
  );
};

export default ActivityGrid;
